const VideoPreview = ({ url }: { url: string }) => {
  return (
    <video
      className="w-full object-cover rounded-xl aichat-video-preview"
      src={url}
      controls
      loop
    >
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPreview;
